<style scoped lang="less">
  @import '../assets/css/less.less';
  h1{ width: 100%; font-size: 36/@r; font-weight: bold; color: #2366af; width: 100%;
    .box; line-height: 3;
  }
  p{ font-size: 30/@r; color: #333333; padding: 60/@r 0 30/@r;line-height: 36/@r;}
  span{display: block; font-size: 30/@r; color: #333333; padding: 60/@r 0 0;}
  textarea{ display: block; width: 100%; resize:none;outline:none; font-size: 28/@r; color: #333;
     height: 324/@r; border-radius: 10/@r; box-sizing: border-box; padding: 20/@r;
     border: 2/@r solid #999999; line-height: 1.6; background: #fff;
  }
  input{ width: 100%; height: 80/@r; border: 2/@r solid #999999; border-radius: 10/@r; font-size: 28/@r;
     padding: 0 26/@r; box-sizing: border-box; background: #fff;
     margin-top: 30/@r;
  }
</style>
<template>
    <div>
        <!-- <h1>拍砖留言板</h1> -->
        <p>10.欢迎留下您宝贵的意见和建议。</p>
        <textarea v-model="msg" maxlength="-1" placeholder="请输入您的建议"></textarea>
        <!-- <span>联系方式:</span>
        <input type="number" v-model="phone" placeholder="请输入联系方式"> -->
    </div>
</template>
<script>
export default {
   data(){
       return{
           msg:"",//留言信息
           phone:"",//手机
       }
   }
}
</script>  


// WEBPACK FOOTER //
// src/components/message.vue